const complaintSubjectSelects = [{
  id: 0,
  value: 0,
  checked: false,
  text: 'อสังหาริมทรัพย์',
}, {
  id: 1,
  value: 1,
  checked: false,
  text: 'สินค้า',
}, {
  id: 2,
  value: 2,
  checked: false,
  text: 'บริการ',
}]

const complaintTypeSelects = [{
  id: 0,
  value: 0,
  checked: false,
  text: 'บ้านจัดสรร (ทาวน์เฮ้าส์)',
}, {
  id: 1,
  value: 1,
  checked: false,
  text: 'บ้านจัดสรร (ทาวน์โฮม)',
}, {
  id: 2,
  value: 2,
  checked: false,
  text: 'บ้านจัดสรร (บ้านแฝด)',
}, {
  id: 3,
  value: 3,
  checked: false,
  text: 'บ้านจัดสรร (บ้านเดี่ยว)',
}, {
  id: 4,
  value: 4,
  checked: false,
  text: 'อาคารชุด/คอนโดมิเนียม',
}, {
  id: 5,
  value: 5,
  checked: false,
  text: 'อพาร์ทเมนต์/หอพัก/ห้องเช่า/บ้านเช่า',
}]

const complaintReasonSelects = [{
  id: 0,
  value: 0,
  checked: false,
  text: 'ขอให้ตรวจสอบโครงการ',
}, {
  id: 1,
  value: 1,
  checked: false,
  text: 'ขอแก้ไขเพิ่มเติมสัญญา',
}, {
  id: 2,
  value: 2,
  checked: false,
  text: 'ขอคำปรึกษา',
}, {
  id: 3,
  value: 3,
  checked: false,
  text: 'ก่อสร้างไม่แล้วเสร็จ',
}, {
  id: 4,
  value: 4,
  checked: false,
  text: 'มีการก่อสร้างแล้วเสร็จแต่เก็บงานไม่เรียบร้อย',
}, {
  id: 5,
  value: 5,
  checked: false,
  text: 'ไม่ปลูกสร้าง',
}]

const complaintPlaceSelects = [{
  id: 0,
  value: 0,
  checked: false,
  text: 'ห้างสรรพสินค้า',
}, {
  id: 1,
  value: 1,
  checked: false,
  text: 'ร้านสะดวกชื้อ',
}, {
  id: 2,
  value: 2,
  checked: false,
  text: 'ที่ตั้งร้านค้า/สาขา',
}, {
  id: 3,
  value: 3,
  checked: false,
  text: 'โรงแรม',
}, {
  id: 4,
  value: 4,
  checked: false,
  text: 'ตลาดนัด',
}, {
  id: 5,
  value: 5,
  checked: false,
  text: 'งานแสดงสินค้า',
}]

const complaintMotivateSelects = [{
  id: 0,
  value: 0,
  checked: false,
  text: 'ทางสื่อสิ่งพิมพ์',
}, {
  id: 1,
  value: 1,
  checked: false,
  text: 'ทางโทรทัศน์',
}, {
  id: 2,
  value: 2,
  checked: false,
  text: 'ทางวิทยุ',
}, {
  id: 3,
  value: 3,
  checked: false,
  text: 'ทางอินเทอร์เน็ต',
}, {
  id: 4,
  value: 4,
  checked: false,
  text: 'คำชักชวนของพนักงานขาย',
}, {
  id: 5,
  value: 5,
  checked: false,
  text: 'อื่นๆ',
}]

const complaintPaymentMethodSelects = [{
  id: 0,
  value: 0,
  checked: false,
  text: 'เงินสด',
}, {
  id: 1,
  value: 1,
  checked: false,
  text: 'เงินผ่อน',
}, {
  id: 2,
  value: 2,
  checked: false,
  text: 'บัตรเครดิต',
}, {
  id: 3,
  value: 3,
  checked: false,
  text: 'เช่าซื้อ',
}, {
  id: 4,
  value: 4,
  checked: false,
  text: 'การชำระเงินผ่านอินเทอร์เน็ต',
}, {
  id: 5,
  value: 5,
  checked: false,
  text: 'อื่นๆ',
}, {
  id: 6,
  value: 6,
  checked: false,
  text: '   เช็ค (Cheque)',
}]

const complaintOnlineRadio = [{
  id: 0,
  value: 0,
  checked: false,
  text: 'ต้องการ',
},
{
  id: 1,
  value: 1,
  text: 'ไม่ต้องการ',
}]

const attachFiles = [{
  id: 0,
  text: 'สำเนาบัตรประจำตัวประชาชน/บัตรข้าราชการ',
  hint: '(**) จำเป็นต้องใส่',
}, {
  id: 1,
  text: 'สำเนาใบเสร็จรับเงิน',
  hint: '',
}, {
  id: 2,
  text: 'หลักฐานแจ้งความประจำวัน',
  hint: '',
}, {
  id: 3,
  text: 'เอกสารโฆษณา',
  hint: '',
}, {
  id: 4,
  text: 'ฉลากสินค้า',
  hint: '',
}, {
  id: 5,
  text: 'ภาพถ่าย',
  hint: '',
}, {
  id: 6,
  text: 'สำเนาสัญญา',
  hint: '',
}]

export {
  complaintSubjectSelects, complaintTypeSelects, complaintReasonSelects, complaintPlaceSelects, complaintMotivateSelects, complaintPaymentMethodSelects, complaintOnlineRadio, attachFiles,
}
